import React from "react";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "./_PageShell";
import RecordList from "./RecordList";

const fields = [
  { key: "name", label: "Name", type: "text", required: true, placeholder: "e.g. Jane Doe" },
  { key: "email", label: "Email", type: "email", placeholder: "jane@company.com" },
  { key: "phone", label: "Phone", type: "text", placeholder: "+91 …" },
  { key: "title", label: "Job title", type: "text", placeholder: "e.g. CEO, Buyer, Parent…" },
  { key: "notes", label: "Notes", type: "textarea", placeholder: "Anything worth remembering…" },
];

export default function Contacts() {
  const { workspace } = useAuth();
  const label = workspace?.labels?.contact || "Contact";
  return (
    <>
      <PageHeader
        eyebrow={`CRM · ${label}s`}
        title={`${label}s`}
        description="People you sell to, support, or follow up with."
      />
      <RecordList
        endpoint="/crm/contacts"
        fields={fields}
        primaryKey="name"
        secondaryKeys={["email", "phone", "title"]}
        emptyHelp={`No ${label.toLowerCase()}s yet — start by adding one.`}
        newLabel={`New ${label.toLowerCase()}`}
        testIdPrefix="contact"
      />
    </>
  );
}
